import axios from "axios";

export const backendUrl = process.env.REACT_APP_BACKEND_URL || "";

// Links shared outside the app (for example, on WhatsApp) need a full URL.
// In production this automatically follows the domain currently open in the browser.
export const publicAppUrl = (
  process.env.REACT_APP_PUBLIC_APP_URL ||
  (typeof window !== "undefined" ? window.location.origin : backendUrl)
).replace(/\/+$/, "");

export const API = axios.create({ baseURL: `${backendUrl}/api` });

API.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("tf_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const imgUrl = (u) => {
  if (!u) return "";
  return u.startsWith("http") ? u : `${backendUrl}${u}`;
};

export const waLink = (phone, message) => {
  let digits = String(phone || "").replace(/\D/g, "");
  if (digits.length === 10) digits = "91" + digits;
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
};

export const getGeoPosition = () =>
  new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: Math.round(p.coords.accuracy) }),
      () => resolve(null),
      { timeout: 8000, maximumAge: 60000 }
    );
  });

export const fmtDate = (d) => (d ? String(d).slice(0, 10) : "-");

export const downloadExcel = async (path, filename) => {
  const r = await API.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const fmtDateTime = (d) => {
  if (!d) return "-";
  const dt = new Date(d);
  return isNaN(dt)
    ? String(d).slice(0, 10)
    : dt
        .toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true })
        .replace(/\b(am|pm)\b/i, (m) => m.toUpperCase());
};

export const money = (v) => (v === null || v === undefined || v === "" ? "—" : inr(v));

export const ROLES = {
  admin: "Admin",
  staff: "Staff",
  sales: "Sales",
  stock_team: "Stock Team",
  stock_head: "Stock Head",
  accountant: "Accountant",
};

export const ROLE_DESCRIPTIONS = {
  admin: "Full access, both firms — can create & manage users",
  staff: "General access (legacy role)",
  sales: "Firm 2 (B2B): CRM, performa invoices; view stock, raise challans",
  stock_team: "Firm 1 (B2C) only: inbound/outbound stock, challan dispatch, Excel export — no prices, no Firm 2 data",
  stock_head: "Firm 1 (B2C) only: all stock settings, purchase & transfer rates, challan dispatch — no Firm 2 data",
  accountant: "Both firms: full B2B books + Firm 1 inventory & challans",
};
